import { Injectable } from '@angular/core';
import { BaseAddressyItem } from '../interfaces/addressy/api/address/find-api.interface';
import { map, Observable, switchMap } from 'rxjs';
import { AddressyResponse } from '../interfaces/addressy/api/addressy-api.interface';
import { AddressyItem } from '../interfaces/addressy/api/address/retrieve-api.interface';
import { convertAddressy2WooCommerce } from '../../shared/utils/addressy-2-woo-commerce.util';
import { AddressyService } from './addressy/addressy.service';
import { WooCommerceShippingApiService } from './woo-commerce/api/woo-commerce-shipping-api.service';
import { BaseWooCommerceAddressDetails } from '../interfaces/woo-commerce/woo-commerce.interface';
import { WooCommerceShippingMethod } from '../interfaces/woo-commerce/api/shipping/shipping-api.interface';
import {
  HappyDeliveryCheckRequest,
  HappyDeliveryCheckResponse
} from '../interfaces/happy-api/happy-api.interface';

export interface DeliveryAddressInfo {
  address: BaseWooCommerceAddressDetails;
  shippingMethods: WooCommerceShippingMethod[];
  isDeliverable: boolean;
}

@Injectable({ providedIn: 'root' })
export class ShippingService {
  constructor(
    private addressyService: AddressyService,
    private wooCommerceShippingApiService: WooCommerceShippingApiService
  ) {}

  getDeliveryAddressInfo(
    address: BaseAddressyItem
  ): Observable<DeliveryAddressInfo> {
    return this.addressyService
      .getAddressDetails(address.Id, address.Text, address.Type)
      .pipe(
        switchMap((response: AddressyResponse<AddressyItem[]>) => {
          const selectedAddress: AddressyItem = response.Items[0];

          return this.checkDeliveryByAddress({
            country_code: selectedAddress.CountryIso2 || 'US',
            state_code: selectedAddress.ProvinceCode || '',
            postcode: (selectedAddress.PostalCode || '').split('-')[0],
            city: selectedAddress.City || ''
          }).pipe(
            map((checkResponse: HappyDeliveryCheckResponse) => ({
              address: convertAddressy2WooCommerce(selectedAddress),
              shippingMethods:
                WooCommerceShippingApiService.mapDeliveryCheckToShippingMethods(
                  checkResponse
                ),
              isDeliverable: checkResponse.is_deliverable
            }))
          );
        })
      );
  }

  checkDeliveryByAddress(
    request: HappyDeliveryCheckRequest
  ): Observable<HappyDeliveryCheckResponse> {
    return this.wooCommerceShippingApiService.deliveryCheck(request);
  }
}
